<template>
  <div class="modal-title">
    <h3>Fijn dat je tevreden bent!</h3>
  </div>
  <div class="star-rating justify-center ">
    <div class="title">Hoeveel sterren geef je ons?</div>
    <div class="star-container ">
      <Icon v-for="(icon, index) in icons" :key="`star-${index}`" @mousedown="setStars(index)" :icon="icon"></Icon>
    </div>
  </div>
  <div class="user-data component-spacing-top">
    <TextInput id="frank_name" v-model="frankStore.feedback.name" :error="testError" label="Naam"></TextInput>
    <TextInput id="frank_email" v-model="frankStore.feedback.email" label="E-mailadres"></TextInput>
    <TextInput id="frank_message" v-model="frankStore.feedback.message" label="Jouw bericht"></TextInput>
  </div>
  <div class="navigation-bar component-spacing-top">
    <link-icon-left
        @click.native="frankStore.goBack()"
        icon="arrow-left-long-solid"
        label="Ga terug"
    ></link-icon-left>

    <button-icon-right
        @click.native="frankStore.submitFeedback()"
        type="cta"
        label="Verstuur feedback"
    ></button-icon-right>
  </div>
</template>

<script setup>
import { useFrankStore } from './store/frankStore.js';
import Icon from '../../../abstracts/elements/icon/Icon.vue';
import { computed, ref, watch } from 'vue';
import LinkIconLeft from '../../../abstracts/elements/link/icon-left/link-icon-left.vue';
import ButtonIconRight from '../../../abstracts/elements/button/icon-right/button-icon-right.vue';
import TextInput from '../../vue-elements/input/TextInput.vue';

const testError = ref('');
const frankStore = useFrankStore();

const icons = computed(() => {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    stars[i] = i < frankStore.rating ? 'star-full' : 'star-empty';
  }
  return stars;
});

const setStars = (index) => {
  frankStore.rating = index + 1;
};

</script>

<style lang="scss">
@use 'assets/scss/all' as *;

.star-container {
  .icon-element {
    @include background-blue;

    transition-property: transform;
    transition-duration: 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
